import { render, staticRenderFns } from "./AppSimpleButton.vue?vue&type=template&id=199b1ed0&scoped=true&"
import script from "./AppSimpleButton.vue?vue&type=script&lang=ts&"
export * from "./AppSimpleButton.vue?vue&type=script&lang=ts&"
import style0 from "./AppSimpleButton.vue?vue&type=style&index=0&id=199b1ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b1ed0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
